import axios from '../../services/axios';

export const DEFAULT_CENTER = { lat: 49.2827, lng: -123.1207 };
export const DEFAULT_ZOOM = 10;
export const GOOGLE_MAP_LIBRARIES = ['places', 'marker'];
export const GOOGLE_MAP_ID = 'fe61dfc0e8bd6f68fa4759e6';

export const isValidLatLng = (pos) =>
  pos && typeof pos.lat === "number" && typeof pos.lng === "number";

// Safe version of fetchLocationName
export async function fetchLocationName(lat, lon) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    console.warn('⛔ fetchLocationName skipped — no token');
    return '';
  }

  try {
    const res = await axios.get(`/api/map/reverse-geocode/?lat=${lat}&lng=${lon}`);
    const data = res.data;
    return data.results?.[0]?.formatted_address || '';
  } catch (err) {
    console.error('📍 fetchLocationName error:', err);
    return '';
  }
}

// Safe version of fetchTimeZone
export async function fetchTimeZone(lat, lon) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    console.warn('⛔ fetchTimeZone skipped — no token');
    return '';
  }

  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const res = await axios.get(`/api/map/timezone/?lat=${lat}&lng=${lon}&timestamp=${timestamp}`);
    const data = res.data;
    return data.timeZoneId || '';
  } catch (err) {
    console.error('🕒 fetchTimeZone error:', err);
    return '';
  }
}
